import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

/**
 * Each season's trophy has its own colour, continuing the rotation the profile has used since
 * S27 (gold, orange, red, pink, purple). Keyed by season so a two-time winner's trophies are
 * told apart at a glance; unknown seasons fall back to gold.
 */
const SEASON_COLORS: Record<number, [string, string, string]> = {
    27: ['#ffc107', '#ffdc5e', '#212529'],
    28: ['#ff8f00', '#ffb347', '#212529'],
    29: ['#ff5722', '#ff8a65', '#212529'],
    30: ['#e91e63', '#f48fb1', '#ffffff'],
    31: ['#7c4dff', '#b388ff', '#ffffff'],
    32: ['#00bcd4', '#6ff2ff', '#212529'],
    33: ['#4ade80', '#a7f3c4', '#212529'],
};

export const seasonTrophyColors = (season: number): [string, string, string] =>
    SEASON_COLORS[season] ?? SEASON_COLORS[27];

type FantasyWinnerBadgeProps = {
    /** The season won, which picks the colour and the tooltip. */
    season: number;
};

/** Awarded to whoever won their division's Fantasy season. One per season won. */
export const FantasyWinnerBadge = ({ season }: FantasyWinnerBadgeProps) => {
    const [from, to, ink] = seasonTrophyColors(season);
    return (
        <span
            className="badge rounded-pill m-1"
            style={{ background: `linear-gradient(135deg, ${from}, ${to})`, color: ink }}
            title={`Vinder af fantasy division S${season}`}
        >
            <EmojiEventsIcon />
        </span>
    )
}
